import React from "react";
import "../../../AllComponentCSS.css";

function JS_some() {
  return (
    <div className="tutorial-page">
      <h1>JS some</h1>
      <p>This page will cover the some topic in detail.</p>
    </div>
  );
}

export default JS_some;
